import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  NumberInput,
  Textarea,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { modals } from "@mantine/modals";

interface UpdateDeliveryPayrollWarranty {
  asssignmentDetailId: number;
  distanceEstimated: number;
  isPayroll: boolean;
  point: number;
  note: string;
}

const EditDataView = ({ data, onClose }: { data: any; onClose: any }) => {
  const [dataSubmit, setDataSubmit] = useState<UpdateDeliveryPayrollWarranty>({
    asssignmentDetailId: data?.assignmentDetailId,
    distanceEstimated: data?.modifiedDistance
      ? Number(data?.modifiedDistance) / 1000
      : 0,
    isPayroll: data?.modifiedPayroll,
    point: data?.modifiedPoint ? Number(data?.modifiedPoint) : 0,
    note: data?.noteByManager,
  });

  const handleSubmit = async () => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDeliveryAssignment/update-delivery-payroll-for-du-an",
      {
        ...dataSubmit,
        distanceEstimated: dataSubmit.distanceEstimated * 1000,
      }
    );

    if (res && res.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 1000);
    }
  };

  return (
    <Box m={"5px 0px"} w={"50vw"} maw={700}>
      <Grid>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <NumberInput
            label="Số km (đã sửa)"
            placeholder="Nhập số kilomet"
            value={dataSubmit?.distanceEstimated || undefined}
            hideControls
            allowNegative={false}
            suffix=" km"
            decimalScale={0}
            fixedDecimalScale
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                distanceEstimated: Number(e) || 0,
              }))
            }
            onFocus={(event) => event.currentTarget.select()}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <NumberInput
            label="Điểm (Đã sửa)"
            placeholder="Nhập điểm"
            value={dataSubmit?.point || undefined}
            hideControls
            allowNegative={true}
            suffix=" điểm"
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                point: Number(e) || 0,
              }))
            }
            onFocus={(event) => event.currentTarget.select()}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={dataSubmit?.note}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                note: e.target.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"space-between"} align={"center"} mt={10}>
        <Checkbox
          label={"Tính lương (Đã sửa)"}
          checked={dataSubmit?.isPayroll}
          onClick={() =>
            setDataSubmit((prev) => ({
              ...prev,
              isPayroll: !dataSubmit?.isPayroll,
            }))
          }
        />
        <Button
          leftSection={<IconCheck size={14} />}
          onClick={() => handleSubmit()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default EditDataView;
